import React from 'react';

class SlideUpDownNav extends React.Component {
    constructor(props){
        super(props);
        this.handleClickUp = this.handleClickUp.bind(this);
        this.handleClickDown = this.handleClickDown.bind(this);
    }

    handleClickUp(e){
        let {fullpageApi} = this.props;
        fullpageApi.moveSectionUp();
    }

    handleClickDown(e){
        let {fullpageApi} = this.props;
        fullpageApi.moveSectionDown();
    }

    componentDidMount(){
        // // select element to unwrap
        // var el = document.querySelector('.nav-wrapper');

        // // get the element's parent node
        // var parent = el.parentNode;

        // // move all children out of the element
        // while (el.firstChild) parent.insertBefore(el.firstChild, el);

        // // remove the empty element
        // parent.removeChild(el);
    }

    render() {
        return (
            // <div className="nav-wrapper" style={this.props.styleProps}>
            //     {this.props.upBtn || this.props.upBtn == undefined &&
            //         <a href="javascript:" className="btn_slideUp" onClick={this.handleClickUp}/>
            //     }

            //     {this.props.downBtn || this.props.downBtn == undefined &&
            //         <a href="javascript:" className="btn_slideDown" onClick={this.handleClickDown}/>
            //     }
            // </div>
            <div></div>
        );
    }
}
export default SlideUpDownNav;



// WEBPACK FOOTER //
// ./src/components/inc/SlideUpDownNav.js